import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon, StarIcon } from 'lucide-react';
type PackType = 'basic' | 'intermediate' | 'complete';
const CHECKOUT_URLS: Record<PackType, string> = {
  basic: 'https://checkoutarg.recursodigital.shop/cart/48507761066203:1',
  intermediate: 'https://checkoutarg.recursodigital.shop/cart/48507764572379:1',
  complete: 'https://checkoutarg.recursodigital.shop/cart/48507766866139:1'
};
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<PackType>('complete');
  return <section id="pricing" className="w-full bg-[#0a0a0a] py-8 md:py-12 px-4 border-t border-gray-800 relative" data-id="element-259">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-260"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-261">
        {/* Countdown */}
        <div className="text-center mb-8 bg-gray-900/80 border border-gray-800 rounded-2xl p-5 backdrop-blur-sm" data-id="element-262">
          <p className="text-yellow-400 font-black text-base md:text-lg mb-3 font-heading tracking-wide" data-id="element-263">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </p>
          <CountdownTimer data-id="element-264" />
          <p className="text-red-400 font-bold text-xs mt-3 font-body uppercase tracking-wider" data-id="element-265">
            Después sube el precio y no vuelve
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-266">
          <h2 className="text-2xl md:text-3xl font-black font-heading text-white mb-2" data-id="element-267">
            💰 ELIGE TU <span className="text-yellow-400" data-id="element-268">MEGAPACK</span>
          </h2>
          <p className="text-gray-400 font-body text-xs md:text-sm" data-id="element-269">
            Todas las opciones incluyen los 6 bonos
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-270">
          {/* Pack Básico */}
          <div onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-center gap-3 ${selectedPack === 'basic' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-271">
            <div className="flex-shrink-0" data-id="element-272">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-273">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-274" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-275">
              <div data-id="element-276">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-277">
                  <span className="text-lg" data-id="element-278">📘</span>
                  <h3 className="text-base md:text-lg font-black font-heading text-white" data-id="element-279">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-xs text-gray-400 font-body" data-id="element-280">
                  6 tomos + 6 bonos
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-281">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-282">
                  ARS 27.990
                </p>
                <p className="text-xl font-black font-heading text-white" data-id="element-283">
                  ARS 19.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Completo (MÁS ELEGIDO - en el medio) */}
          <div onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-start md:items-center gap-3 ${selectedPack === 'complete' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.25)] scale-[1.02] z-10 relative' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-284">
            <div className="flex-shrink-0 mt-1 md:mt-0" data-id="element-285">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'complete' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-286">
                {selectedPack === 'complete' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-287" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-3" data-id="element-288">
              <div data-id="element-289">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-290">
                  <span className="text-lg" data-id="element-291">🏆</span>
                  <h3 className="text-base md:text-lg font-black font-heading text-white" data-id="element-292">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-2" data-id="element-293">
                  <span className="bg-yellow-400 text-black text-[9px] font-black px-2 py-0.5 rounded flex items-center gap-1 font-heading tracking-wide" data-id="element-294">
                    <StarIcon className="w-2.5 h-2.5 fill-black" data-id="element-295" /> MÁS ELEGIDO
                  </span>
                </div>
                <p className="text-xs text-gray-400 font-body mb-1.5 font-medium" data-id="element-296">
                  TODO lo anterior +
                </p>
                <ul className="space-y-1" data-id="element-297">
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-298">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-299" />
                    Sistema de Personalización PRO
                  </li>
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-300">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-301" />
                    Sistema de Casos Difíciles
                  </li>
                  <li className="text-xs text-gray-300 font-body flex items-center gap-1.5" data-id="element-302">
                    <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-303" />
                    Sistema de Implementación Real
                  </li>
                </ul>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-304">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-305">
                  ARS 79.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-306">
                  ARS 27.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Intermedio */}
          <div onClick={() => setSelectedPack('intermediate')} className={`cursor-pointer rounded-xl p-4 md:p-5 border-2 transition-all duration-300 flex items-center gap-3 ${selectedPack === 'intermediate' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-307">
            <div className="flex-shrink-0" data-id="element-308">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'intermediate' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-309">
                {selectedPack === 'intermediate' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-310" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-311">
              <div data-id="element-312">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-313">
                  <span className="text-lg" data-id="element-314">📗</span>
                  <h3 className="text-base md:text-lg font-black font-heading text-white" data-id="element-315">
                    PACK INTERMEDIO
                  </h3>
                </div>
                <p className="text-xs text-gray-400 font-body" data-id="element-316">
                  Pack Básico + Manual Completo de Comunicación
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-317">
                <p className="text-[10px] text-gray-500 line-through font-body" data-id="element-318">
                  ARS 49.990
                </p>
                <p className="text-xl font-black font-heading text-white" data-id="element-319">
                  ARS 23.990
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-6" data-id="element-320">
          <a href={CHECKOUT_URLS[selectedPack]} className="block w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl py-4 rounded-xl text-center transition-all duration-300 cursor-pointer font-heading shadow-[0_0_20px_rgba(250,204,21,0.3)] hover:shadow-[0_0_30px_rgba(250,204,21,0.4)] hover:scale-[1.01]" data-id="element-321">
            👉 QUIERO MI MEGAPACK AHORA
          </a>
          <div className="flex flex-wrap justify-center gap-3 md:gap-5 mt-4 text-[10px] md:text-xs text-gray-400 font-body font-medium" data-id="element-322">
            <span className="flex items-center gap-1 bg-gray-900 px-2.5 py-1 rounded-lg border border-gray-800" data-id="element-323">
              🔒 Pago seguro
            </span>
            <span className="flex items-center gap-1 bg-gray-900 px-2.5 py-1 rounded-lg border border-gray-800" data-id="element-324">
              ⚡ Acceso inmediato
            </span>
            <span className="flex items-center gap-1 bg-gray-900 px-2.5 py-1 rounded-lg border border-gray-800" data-id="element-325">
              🛡️ Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}